module.exports = __webpack_public_path__ + "static/media/Logo-p5.433937e1.png";